/**
 * PDP story / artist bio — "Show more" (owner ask 2026-10-13).
 *
 * Progressive enhancement over sections/main-product.liquid: the COMPLETE story
 * or bio is always in the server HTML, so crawlers and shoppers without JS see
 * all of it and no button. This script only clamps a `[data-pdp-more]` block
 * that runs past ~5 lines and appends a text-link toggle after it:
 *   <button type="button" class="pdp__more" aria-expanded="false">Show more</button>
 * which flips to "Show less" (aria-expanded="true"). A block that fits gets
 * nothing. Never throws on the PDP.
 *
 * Tests: tests/pdp-about-more.dom.test.mjs
 */

const LINES = 5;
// Clamp only when hiding at least ~one more line is worth a click.
const SLACK_LINES = 0.75;

function lineHeightOf(el) {
  const cs = window.getComputedStyle(el);
  const lh = parseFloat(cs.lineHeight);
  if (Number.isFinite(lh) && lh > 0) return lh;
  const fs = parseFloat(cs.fontSize);
  return (Number.isFinite(fs) && fs > 0 ? fs : 13) * 1.5;
}

function reducedMotion() {
  try {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  } catch (_) {
    return false;
  }
}

let seq = 0;

function enhance(box) {
  if (box.dataset.pdpMoreReady) return;
  const lh = lineHeightOf(box.firstElementChild || box);
  const max = Math.round(lh * LINES);
  if (!(box.scrollHeight > max + lh * SLACK_LINES)) return;
  box.dataset.pdpMoreReady = '1';

  if (!box.id) box.id = `pdp-more-${++seq}`;
  box.style.setProperty('--pdp-more-max', `${max}px`);
  box.classList.add('is-clamped');

  const btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'pdp__more';
  btn.setAttribute('aria-controls', box.id);
  btn.setAttribute('aria-expanded', 'false');
  btn.textContent = 'Show more';
  btn.addEventListener('click', () => {
    const open = btn.getAttribute('aria-expanded') !== 'true';
    box.classList.toggle('is-clamped', !open);
    btn.setAttribute('aria-expanded', String(open));
    btn.textContent = open ? 'Show less' : 'Show more';
    if (!open && typeof box.scrollIntoView === 'function') {
      // Collapsing can leave the reader below the block; bring its start back.
      const r = box.getBoundingClientRect();
      if (r.top < 0) box.scrollIntoView({ block: 'start', behavior: reducedMotion() ? 'auto' : 'smooth' });
    }
  });
  box.after(btn);
}

function init(root = document) {
  for (const box of root.querySelectorAll('[data-pdp-more]')) {
    try {
      enhance(box);
    } catch (_) {
      // Leave the full, unclamped text on screen.
    }
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => init());
} else {
  init();
}
// Web fonts can change line wrapping after first paint; re-check blocks that
// did not overflow before (an already-enhanced block is left alone).
if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => init()).catch(() => {});
